import { FunctionComponent, useEffect, useState } from "react";
import { fetchStatus } from "./status-api";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

export const StatusView: FunctionComponent = () => {
  const version = useVersion();

  return (
    <div>
      <Typography
        component="h4"
        variant="body2"
      >
        <FormattedMessage id="APIVersion" /> {version}
      </Typography>
    </div>
  );
};

const useVersion = () => {
  const [version, setVersion] = useState('');

  const fetchVersion = async () => {
    const response = await fetchStatus();
    setVersion(response.data.version);
  };

  useEffect(() => {
    fetchVersion();
  }, []);

  return version;
};